import React, { useState } from "react";
// oxlint-disable-next-line no-restricted-imports -- Legacy migration debt — do not copy into new code.
import { Collapsible } from "@design-system/Collapsible/Collapsible";
import { BooleanControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./structureLayoutControls.module.scss";

export const CollapsiblePlayground = () => {
    const [isOpen, setIsOpen] = useState(true);
    const [isStacked, setIsStacked] = useState(false);
    const [hasFooter, setHasFooter] = useState(true);

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Features</h2>
                    <div className={styles.booleanGrid}>
                        <BooleanControl
                            label="Open"
                            checked={isOpen}
                            onChange={setIsOpen}
                        />
                        <BooleanControl
                            label="Stacked"
                            checked={isStacked}
                            onChange={setIsStacked}
                        />
                        <BooleanControl
                            label="Footer"
                            checked={hasFooter}
                            onChange={setHasFooter}
                        />
                    </div>
                </section>
            }
        >
            <ShowcasePreview
                summary={isOpen ? "Expanded" : "Collapsed"}
                width="wide"
                output={JSON.stringify(
                    {
                        componentProps: {
                            open: isOpen,
                            stacked: isStacked,
                            footer: hasFooter,
                        },
                        showcaseState: {},
                    },
                    null,
                    2,
                )}
            >
                <Collapsible
                    header="August bookkeeping summary"
                    open={isOpen}
                    onToggle={setIsOpen}
                    stacked={isStacked}
                    footer={hasFooter ? "Updated a few seconds ago" : undefined}
                >
                    <div className={styles.contentBlock}>
                        <h3>Books are ready for review</h3>
                        <p>
                            All imported transactions have been categorized and
                            reconciled.
                        </p>
                    </div>
                </Collapsible>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
